import { useMemo } from 'react';
import { calculateFooter } from './useFooterCalculation';
import { GROUPBY } from '../../../../constants/Reports';

export const useTownRows = (raw, columns, groupby) =>
  useMemo(() => {
    const source = (raw && raw.data) || raw;
    if (!source || typeof source !== 'object') return [];

    return Object.entries(source).map(([groupTitle, rows]) => {
      const items = (rows || []).map((arrRow, rowIndex) => {
        if (groupby === GROUPBY[0].value) {
          const [date, shift, description, hours] = arrRow;
          return {
            id: rowIndex,
            date,
            shift,
            description,
            hours,
          };
        }

        if (groupby === GROUPBY[1].value) {
          const [employee, shift, description, hours] = arrRow;
          return {
            id: rowIndex,
            employee,
            shift,
            description,
            hours,
          };
        }

        return {};
      });

      const footer = calculateFooter(items, columns);

      return {
        name: groupTitle,
        items,
        footer,
      };
    });
  }, [raw, columns, groupby]);
